export default __webpack_public_path__ + "static/Entenda0061-994bc7049b31ab430f5841039809ac4f.jpg";